import { render, staticRenderFns } from "./AmazonSilver.vue?vue&type=template&id=11587bf1&lang=pug"
import script from "./AmazonSilver.js?vue&type=script&lang=js&external"
export * from "./AmazonSilver.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports